import { Control } from 'ol/control';

export class RecentrerVueControl extends Control {
  /**
   * @param {Object} [opt_options] Control options.
   */
  constructor(opt_options) {
    const options = opt_options || {};
    const button = document.createElement('button');
    // On utilise un background-image
    button.innerHTML = '&nbsp;';
    button.title = "Centrer sur l'emprise de départ";

    const element = document.createElement('div');
    element.className = 'ol-recentrer-vue ol-unselectable ol-control';
    element.appendChild(button);

    super({
      element: element,
      target: options.target,
    });

    this.extent = options.extent;

    button.addEventListener('click', this.recentrer.bind(this), false);
  }

  recentrer() {
    this.getMap().getView().fit(this.extent);
  }
}
